import { Button } from '@astryxdesign/core/Button';
import { Heading } from '@astryxdesign/core/Heading';
import { HStack } from '@astryxdesign/core/HStack';
import { List, ListItem } from '@astryxdesign/core/List';
import { Section } from '@astryxdesign/core/Section';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { useMemo } from 'react';
import { EmptyView } from '@/components/StateViews';
import { useBookingFlow } from '@/features/booking/useBookingFlow';
import { useStudioData } from '@/features/studio/StudioContext';
import { fmtDuration, fmtMoney } from '@/lib/format';

export function ServicesPage() {
  const studio = useStudioData();
  const flow = useBookingFlow();
  const groups = useMemo(() => {
    const m = new Map<string, typeof studio.services>();
    for (const s of studio.services) m.set(s.category || 'Услуги', [...(m.get(s.category || 'Услуги') ?? []), s]);
    return [...m.entries()];
  }, [studio.services]);

  return (
    <VStack gap={6} paddingInline={4} paddingBlock={6} className="page-column">
      <VStack gap={1}>
        <Heading level={1}>Услуги и цены</Heading>
        <Text color="secondary">Длительность уже включает подготовку поста — приезжайте ко времени записи.</Text>
      </VStack>
      {groups.length === 0 && <EmptyView title="Услуги пока не добавлены" description={`Позвоните: ${studio.settings.phone}`} />}
      {groups.map(([category, services]) => (
        <Section key={category} padding={0} variant="transparent">
          <List hasDividers density="spacious" header={<Heading level={2}>{category}</Heading>}>
            {services.map((s) => (
              <ListItem
                key={s.id}
                label={s.name}
                description={
                  <VStack gap={1}>
                    {s.description && <Text color="secondary">{s.description}</Text>}
                    <HStack gap={3}>
                      <Text weight="semibold" hasTabularNumbers>
                        {fmtMoney(s.priceCents, studio.currency, s.priceIsFrom)}
                      </Text>
                      <Text color="secondary">{fmtDuration(s.durationMin)}</Text>
                    </HStack>
                  </VStack>
                }
                endContent={<Button label="Записаться" size="sm" variant="primary" onClick={() => flow.open(s.id)} />}
              />
            ))}
          </List>
        </Section>
      ))}
    </VStack>
  );
}
